<script>

    // https://developer.mozilla.org/en-US/docs/Web/API/FileReader
    // https://iqcode.com/code/javascript/converting-file-to-base64-on-javascript-client-side
    // https://img.ly/blog/how-to-compress-an-image-before-uploading-it-in-javascript/

    /*
I found a solution. Figured I'd share it here for those struggling to get it all working.

Client-side, I read the file as base64 and pass it in JSON:

const file = data.image.split(';base64,').pop()
const fileBuffer = Buffer.from(file, 'base64')
const reader = new FileReader()
reader.onload = async (e) => {
  const res = await fetch('/', {
    method: 'POST',
    body: JSON.stringify({image: e.target.result})
  })
}
Server-side, I create a new buffer from the base64. Supabase seems to be happy with this buffer.

--

const file = data.image.split(';base64,').pop()
const fileBuffer = Buffer.from(file, 'base64')

For increased performance, I switched on another methodology :

Client-side : Read all images, transform them as an arrayBuffer, concat them as an arrayBuffer, and fill the content
type header with custom data : width of images and their respective size in terms of ArrayBuffer length.

CloudFlare Workers : Read data as ArrayBuffer, read the content type header, and, since I know the boundaries,
process all images asynchronously (Promise.all).

This is a lot faster, like 10ms.

    */

    import {onMount} from "svelte";
    import {filemanager} from "../stores/misc";
    import {filenameWithoutExtension, fileExtensionFromFilename} from "../../../../../lib/utils";

    let fileinput;
    export const doClick = () => {
        fileinput.click();
    };
    onMount(() => {
        filemanager.setDOMEl(fileinput);
    });


    const readFileAsDataURLAsync = file => {
        return new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => resolve(fr.result);
            fr.onerror = reject;
            fr.readAsDataURL(file);
        });
    };

    const onFileSelected = async e => {
        let files = [...e.target.files]; // target.files is FileList object, so need to cast it to Array using the spread operator
        let files_base64_arr = await Promise.all(files.map(readFileAsDataURLAsync));
        let payload = files.map((file, i) => {
            return {
                filename: file.name,
                name: filenameWithoutExtension(file.name),
                extension: fileExtensionFromFilename(file.name),
                size: file.size,
                type: file.type,
                file: files_base64_arr[i]
            };
        });
        // console.log(payload);
        filemanager.markAsUploading();
        const url = `/api/file`;
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        });
        //console.log(await response.json());
        filemanager.serverResponse(await response.json());
    };

    const xonFileSelected =(e)=>{
        console.log(e.target.files[0])
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async e => {
            if(file.type.split('/')[0] === 'image') {
                // avatar = e.target.result
            }
            let payload = JSON.stringify({
                filename: file.name,
                size: file.size,
                type: file.type,
                file: reader.result
            });
            console.log(payload);
            const url = `/api/fileupload`;
            const response = await fetch(url, {
                method: 'POST',
                body: payload
            });
            //console.log(await response.json());
            filemanager.serverResponse(await response.json());
        };
    }

</script>

<!--{#if avatar}-->
<!--    <img class="avatar" src="{avatar}" alt="d" />-->
<!--{:else}-->
<!--    <img class="avatar" src="https://cdn4.iconfinder.com/data/icons/small-n-flat/24/user-alt-512.png" alt="" />-->
<!--{/if}-->
<!--<img class="upload" src="https://static.thenounproject.com/png/625182-200.png" alt="" on:click={()=>{fileinput.click();}} />-->
<!--<div class="chan" on:click={()=>{fileinput.click();}}>Choose Image</div>-->
<input style="display:none" type="file" accept=".jpg, .jpeg, .png" multiple on:change={(e)=>onFileSelected(e)} bind:this={fileinput} >

<style></style>